/*eslint-disable no-unused-vars*/
import React from 'react';
import { Line } from 'react-konva';
import { relatedColor, unrelatedColor, lineCap, strokeWidth } from '../../library/constants';

const ProngComponent = ({ child, nodeObjs, endYOfHandle, nodeIsRelated, unionColor, stageBackgroundCustomColor}) => {
  const n = child;
  const topOfProng = endYOfHandle + .25;
  const xProngPos = nodeObjs[n].xCenter;
  let bottomOfProng = nodeObjs[child].top ;
  const coordinates = [xProngPos, topOfProng, xProngPos, bottomOfProng];
  const getUnrelatedColor = () => {
    return typeof(unionColor) !== 'undefined' ? unionColor : unrelatedColor;
  }
  let color = ( nodeIsRelated ? relatedColor: getUnrelatedColor());
  color = typeof(stageBackgroundCustomColor) !== 'undefined' && stageBackgroundCustomColor === '#000000' ? '#FFFFFF': color;
  return (
    <Line
      points = {coordinates}
      stroke = {color}
      strokeWidth = {strokeWidth}
      lineCap = {lineCap}
      perfectDrawEnabled={false}
      listening={false}
    />
  );
};

export default ProngComponent;
